<div id="content" class="allcp-form" ng-controller="PaymentController" ng-init="init()">
    <div ng-include="'modules/customer/partials/top_menu.html'"></div>
    <div class="row">
        <h3 class="text-center">Kredi İşlemleri</h3>
        
        <div class="col-md-8 col-md-offset-2">
            <div class="panel">
<!--                 <div class="panel-title text-center">
                    <p style="font-size:20px">
                        Referans Kodunuz : <code style="font-size:20px">{{ data.reference_key }}</code>
                        <span class="hint--medium hint--bottom" aria-label="Referans Kodu Neye yarar?:
                        Referans kodu Teleskop Uygulamasına katılmasını istediğiniz ve vesile olduğunuz şahıs ve firmalara vereceğiniz panelinizde bulunan özel koddur. Bu sayede sizin verdiğiniz referans kodu ile kayıt olan şahıs ve firmalar kayıtlarını tamamladıklarında sizlere ektra kullanım süresi eklenir.
                        Ektra kullanım süresi nasıl olur?
                        Referansınızla Teleskop Uygulamasına yönlendirdiğiniz şirket veya şahısları 1 yıllık kayıt aldığında 3, 6 aylık üyelik paketi aldıklarında hesabınıza ek 1 ay Ekstra kullanım süresi eklenir."><i class="fa fa-question-circle"></i> </span>
                    </p>
                    <p style="font-size:20px">
                        Referans Kodlu Kayıt Linki : <code><a href="#" ng-click="copyToClipBoard('https://uygulama.Hodxpress.com/login?ref='+data.reference_key)">https://uygulama.Hodxpress.com/login?ref={{ data.reference_key }}</a></code>
                    </p>
                    <strong 
                        class="fs16"
                        ng-if="data.remaining_day > 0">
                        Hesabınızın kapanmasına {{ data.remaining_day }} gün kalmıştır.
                    </strong>
                    <strong 
                        class="fs16" 
                        ng-if="data.remaining_day < 0">
                        Hesabınızın süresi bitmiştir. Devam edebilmek için bir paket satın almanız gerekmektedir.
                    </strong>
                </div> -->
                <div class="panel-body">
                    <div class="row">
                        <div class="col-md-7 text-center">
                            <h5>Kaç krediye ihtiyacınız var ?</h5>
                        </div>

                        <div class="col-md-5">
                            <div class="col-md-12">
                                <label class="field select" style="z-index: 7;">
                                    <select 
                                        id="filter-status" 
                                        name="filter-status" class="empty" 
                                        ng-model="userCount"
                                        ng-options="value.number as value.name for (key, value) in workerCount">
                                        <option value="" disabled selected ng-selected="true">Kredi Seç</option>
                                    </select>
                                    <i class="arrow"></i>
                                </label>
                            </div><!-- 
                            <div class="col-md-12 mt20">
                                <label class="radio-inline mr10">
                                    <input type="radio" name="time" id="time2" ng-click="setValue(6)" value="6" ng-model="time"> 6 Ay
                                </label>
                                <label class="radio-inline mr10">
                                    <input type="radio" name="time" id="time2" ng-click="setValue(12)" value="12" ng-model="time"> 1 Yıl
                                </label>
                            </div> -->
                        </div>

                        <div class="col-md-12 mt20" ng-if="userCount != 0">
                            <div class="col-md-12">
                                <p class="text-center text-danger" style="font-weight: 200;font-size: 25px;text-decoration: line-through;">
                                    {{ userCount * 1.2 * 55 * time | number:2 }} ₺
                                </p>
                            </div>
                            <div class="col-md-12">
                                <p class="text-center" style="font-weight: 200;font-size: 36px;">
                                    {{ calculatePrice() }} ₺ <small class="fs13"> KDV Dahil</small> <small>/ {{ time != 12 ? time + ' ay' : ' yıl'}}</small>
                                </p>
                            </div>
                            <div class="col-md-12 text-center">
                                <a href="" class="btn btn-success" ng-click="payment()">Ödeme Yap</a>
                            </div>
                        </div>

                    </div>

                    <div class="col-md-12">
                        <hr>
                        <h5 class="text-center text-muted">Tüm müşterilerimizin yararlanacağı hizmetler.</h5>
                        <div class="col-md-12 text-center mt10">
                            <span>
                                <i class="fa fa-check-circle-o" style="color: #24ca24;font-style: normal;"></i> Özel kargo fiyatları
                            </span>
                        </div>
                        <div class="col-md-12 text-center mt10">
                            <span>
                                <i class="fa fa-check-circle-o" style="color: #24ca24;font-style: normal;"></i> Sınırsız canlı destek
                            </span>
                        </div>
                        <div class="col-md-12 text-center mt10">
                            <span>
                                <i class="fa fa-check-circle-o" style="color: #24ca24;font-style: normal;"></i> Ücretsiz haftalık analiz bülteni
                            </span>
                        </div>
                        <div class="col-md-12 text-center mt10">
                            <span>
                                <i class="fa fa-check-circle-o" style="color: #24ca24;font-style: normal;"></i> Ücretsiz adresten alım
                            </span>
                        </div>
                        <div class="col-md-12 text-center mt10">
                            <span>
                                <i class="fa fa-check-circle-o" style="color: #24ca24;font-style: normal;"></i> Özel müşteri temsilcisi
                            </span>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>

    </div>

    <div class="modal fade" id="paymentDetail" tabindex="-1" role="dialog" aria-labelledby="paymentDetailLabel">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title" id="paymentDetailLabel">Ödeme!</h4>
                </div>
                <div class="modal-body">
                    
                </div>
                <div class="modal-footer bg-light">
                    <button type="submit" class="btn pull-left btn-primary" ng-click="paymentDetail()">Sil</button>
                    <button type="button" class="btn pull-left btn-default" data-dismiss="modal" data-toggle="modal" data-target="#orderDetail" >İptal</button>
                </div>
            </div>
        </div>
    </div>

</div>